var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMechanicPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 13.2437C12.3323 13.4502 12.7247 13.5604 13.125 13.5625C13.7215 13.5618 14.2934 13.3246 14.7153 12.9028C15.1371 12.4809 15.3743 11.909 15.375 11.3125C15.3724 11.1179 15.3442 10.9244 15.2911 10.7372L13.9204 12.1079C13.816 12.2124 13.6918 12.2949 13.5553 12.3514C13.4189 12.4079 13.2727 12.437 13.125 12.437C12.9773 12.437 12.8311 12.4079 12.6947 12.3514C12.5582 12.2949 12.4343 12.2121 12.3298 12.1077C12.2254 12.0032 12.1426 11.8793 12.0861 11.7428C12.0296 11.6064 12.0005 11.4602 12.0005 11.3125C12.0005 11.1648 12.0296 11.0186 12.0861 10.8822C12.1426 10.7457 12.2254 10.6218 12.3298 10.5173L13.7003 9.14637C13.513 9.09334 13.3196 9.06514 13.125 9.0625C12.5285 9.06317 11.9566 9.30044 11.5347 9.72225C11.1129 10.1441 10.8757 10.716 10.875 11.3125C10.8771 11.7129 10.9873 12.1053 11.1939 12.4482L8.0625 15.5796L8.85793 16.375L11.9893 13.2437Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 1.75H10.875V0.625H9.75V1.75H5.25V0.625H4.125V1.75H1.875C1.57663 1.75 1.29048 1.86853 1.0795 2.0795C0.868526 2.29048 0.75 2.57663 0.75 2.875V14.125C0.75 14.4234 0.868526 14.7095 1.0795 14.9205C1.29048 15.1315 1.57663 15.25 1.875 15.25H6.375V14.125H1.875V2.875H4.125V4H5.25V2.875H9.75V4H10.875V2.875H13.125V7.375H14.25V2.875C14.25 2.57663 14.1315 2.29048 13.9205 2.0795C13.7095 1.86853 13.4234 1.75 13.125 1.75Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicPlan);
export default __webpack_public_path__ + "static/media/mechanic_plan.ad7064567d017c08a760a3f7d1b07ffe.svg";
export { ForwardRef as ReactComponent };